import { Icon20InfoCircleOutline } from '@vkontakte/icons';
import React, { memo, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { IS_PHONE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { dispatchAddCardCommunication } from 'reactApp/hooks/subscriptionCommunication';
import { getUnbindCardBannerTitle } from 'reactApp/hooks/subscriptionCommunication.helpers';
import { useGoToSubscriptions } from 'reactApp/hooks/useGoToSubscriptions';
import type { BillingDataSubscriptionInfo } from 'reactApp/modules/billingData/billingData.types';
import autoRenewalStyles from 'reactApp/ui/AutoRenewalBanner/AutoRenewalBanner.css';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import { sendDwh } from 'reactApp/utils/ga';

const ANALYTICS_NAME = 'mnz_unbind_card_banner';

const sendDwhEvent = (action: 'show' | 'click') => {
    sendDwh({
        eventCategory: 'banner',
        action,
        dwh_enabled: true,
        dwhData: {
            name: ANALYTICS_NAME,
            platform: IS_PHONE_BROWSER ? 'touch' : 'web',
            ...(action === 'click' ? { button_name: 'add_card' } : {}),
        },
    });
};

interface UnbindCardBannerProps {
    subscription: BillingDataSubscriptionInfo;
}

export const UnbindCardBanner = memo(({ subscription }: UnbindCardBannerProps) => {
    const dispatch = useDispatch();
    const { goToSubscriptions } = useGoToSubscriptions();

    const handleAddCard = useCallback(() => {
        if (!subscription) {
            return;
        }

        sendDwhEvent('click');
        dispatchAddCardCommunication(dispatch, subscription);
        goToSubscriptions();
    }, [dispatch, goToSubscriptions, subscription]);

    useEffect(() => {
        sendDwhEvent('show');
    }, []);

    const title = getUnbindCardBannerTitle(subscription);
    const subtitle = 'Файлам может не хватить места. Если так случится, в Почте и Облаке появятся ограничения';

    return (
        <div className={autoRenewalStyles.root}>
            <Icon20InfoCircleOutline className={autoRenewalStyles.icon} />
            <div className={autoRenewalStyles.content}>
                <div className={autoRenewalStyles.title}>{title}</div>
                <div className={autoRenewalStyles.text}>{subtitle}</div>
            </div>
            <div className={autoRenewalStyles.buttons}>
                <Button
                    className={autoRenewalStyles.button}
                    data-name="primary-bttn"
                    data-qa-id="primary-bttn"
                    theme="octavius"
                    sizeMode={ButtonSizeMode.small}
                    onClick={handleAddCard}
                >
                    Добавить карту
                </Button>
            </div>
        </div>
    );
});

UnbindCardBanner.displayName = 'UnbindCardBanner';
